// import React from 'react';
// import { BrowserRouter, Route, Switch } from "react-router-dom";
// import CreateRoom from "./routes/CreateRoom";
// import Room from "./routes/Room";

// function App() {
//   return (
//     <BrowserRouter>
//       <Switch>
//         <Route path="/" exact component={CreateRoom} />
//         <Route path="/room/:roomID" component={Room} />
//       </Switch>
//     </BrowserRouter>
//   );
// }

// export default App;
import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./routes/Home";
import CreateRoom from "./routes/CreateRoom";
import Room from "./routes/Room";
import JoinRoom from "./routes/JoinRoom"; // Username input

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/create" component={CreateRoom} />
        <Route path="/join/:roomID" component={JoinRoom} />
        <Route path="/room/:roomID" component={Room} />
        {/* <Route exact path="/join" component={JoinRoom} /> */}
        {/* <Route exact path="/room/:roomID" component={Room} /> */}
      </Switch>
    </BrowserRouter>
  );
}

export default App;
